
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-255cf894&scoped=true!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./NewFeedbackModal.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./NewFeedbackModal.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-255cf894!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./NewFeedbackModal.vue"),
  /* scopeId */
  "data-v-255cf894",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/app/components/modals/NewFeedbackModal.vue
// module id = 120
// module chunks = 61